import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { useToast } from "../other/Toast";
import { classNames } from "primereact/utils";
import { useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useHistory } from "react-router";
import ApiService from "../service/apiService";
import { Password } from "primereact/password";
import { useTranslation } from "react-i18next";
import SecurityService from "../service/SecurityService";
import { Card } from "primereact/card";
import { Tag } from 'primereact/tag'

const ResetPassword = () => {
  const toast = useToast();
  const history = useHistory();
  const { t } = useTranslation();
  const [password, setPassword] = useState();
  const [rePassword, setRePassword] = useState();
  const [verificationCode, setVerificationCode] = useState();
  const [email, setEmail] = useState();

  const {
    control,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm({});
  const getFormErrorMessage = (name) => {
    return (
      errors[name] && <small className="p-error">{errors[name].message}</small>
    );
  };

  const showFormErrorMessage = (message) => {
    return <small className="p-error">{message}</small>
  };

  const header = () => (
    <h3 className="p-col-12 p-md-12 text-center">
      <i className="pi pi-user" /> Reset Password
    </h3>
  );

  const lowerCase = (str) => {
    return /[a-z]/g.test(str);
  };
  const upperCase = (str) => {
    return /[A-Z]/g.test(str);
  };
  const isNumber = (str) => {
    var regex = /\d+/g;
    return regex.test(str);
  };
  const isSpecialChar = (str) => {
    return /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(str);
  };
  const islength = (str, len) => {
    return str.length >= len ? true : false;
  };
  const [lowerCaseColor, setLowerCaseColor] = useState("danger");
  const [upperCaseColor, setUpperCaseColor] = useState("danger");
  const [minNumberColor, setMinNumberColor] = useState("danger");
  const [specialCharColor, setSpecialCharColor] = useState("danger");
  const [lengthColor, setLengthColor] = useState("danger");

  const [lowerCaseCheck, setLowerCaseCheck] = useState("pi pi-times");
  const [upperCaseCheck, setUpperCaseCheck] = useState("pi pi-times");
  const [minNumberCheck, setMinNumberCheck] = useState("pi pi-times");
  const [specialCharCheck, setSpecialCharCheck] = useState("pi pi-times");
  const [lengthCheck, setLengthCheck] = useState("pi pi-times");
  const passwordKeyPressed = (event) => {

    if (lowerCase(event.target.value)) {
      setLowerCaseColor("success");
      setLowerCaseCheck("pi pi-check");
    } else {
      setLowerCaseColor("danger");
      setLowerCaseCheck("pi pi-times");
    }

    if (upperCase(event.target.value)) {
      setUpperCaseColor("success");
      setUpperCaseCheck("pi pi-check");
    } else {
      setUpperCaseColor("danger");
      setUpperCaseCheck("pi pi-times");
    }

    if (isNumber(event.target.value)) {
      setMinNumberColor("success");
      setMinNumberCheck("pi pi-check");
    } else {
      setMinNumberColor("danger");
      setMinNumberCheck("pi pi-times");
    }

    if (isSpecialChar(event.target.value)) {
      setSpecialCharColor("success");
      setSpecialCharCheck("pi pi-check");
    } else {
      setSpecialCharColor("danger");
      setSpecialCharCheck("pi pi-times");
    }

    if (islength(event.target.value, 8)) {
      setLengthColor("success");
      setLengthCheck("pi pi-check");
    } else {
      setLengthColor("danger");
      setLengthCheck("pi pi-times");
    }
  };
  const saveNewPassword = () => {
    let data = {};
    if (password === rePassword) {
      data = {
        password,
        rePassword,
        verificationCode,
        email,
      };
    } else {
      toast.error("Password doesn't match");
      return;
    }
    SecurityService.resetPassword(data)
      .then((response) => {
        if (response.data.msg === "success")
          toast.success("Successful", "Password Sucessfully Changed")
        window.location.href = "/login";
      })
      .catch((error) => {
        toast.error("Error Message", error.response && error.response.data && error.response.data.msg);
      });
  };
  return (
    <div className="compact-layout landing-page-card">
      <div
        style={{
          width: '50%',
          display: "flex",
          alignContent: "center",
          justifyContent: "center",
          placeContent: "center",
          backgroundColor: "#fff",
        }}
        className="p-col-12"
      >
        <div style={{ padding: 0, paddingBottom: 20 }} className="col-md-12">
          <div
            className="p-grid p-fluid"
            style={{ borderBottom: "1px solid #efefef" }}
          >
            <div
              style={{
                fontSize: 15,
                textAlign: "center",
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignContent: "center",
                alignItems: "center",
                padding: 20,
              }}
              className="p-col-12 p-md-12"
            >
              <img src="./cdsc-Blue-Logo.png" style={{ height: 50 }} />{" "}
              <span
                style={{
                  paddingLeft: 10,
                  fontSize: 36,
                  textAlign: "center",
                  color: "#008080",
                  fontFamily: "'Spectral', serif",
                  transform: "scale(1.25,1)",
                }}
              >
                CKYC
              </span>
            </div>
          </div>
          <div className="p-grid p-fluid" style={{ padding: 20 }}>
            {/*   <div className="p-field p-col-12 p-md-12">
              <label className="p-col-12 p-md-12" htmlFor="email">
                <i className="pi pi-envelope"></i> {t("email")}
              </label>
              <div className="p-inputgroup">
                <Controller
                  name="email"
                  control={control}
                  rules={{ required: "Email is required." }}
                  render={({ field, fieldState }) => (
                    <InputText
                      id={field.name}
                      {...field}
                      placeholder={t("email")}
                      onChange={(e) => {
                        field.onChange(e.target.value);
                        setEmail(e.target.value);
                      }}
                    />
                  )}
                />
              </div>
              {getFormErrorMessage("email")}
            </div> */}
            <div className="p-field p-col-12 p-md-12 ">
              <label className="p-col-12 p-md-12" htmlFor="verificationCode">
                {t("verificationCode")}
              </label>
              <div className="p-inputgroup">
                <Controller
                  name="verificationCode"
                  control={control}
                  rules={{ required: "Verification Code is required." }}
                  render={({ field, fieldState }) => (
                    <InputText
                      id={field.name}
                      {...field}
                      placeholder={t("verificationCode")}
                      onChange={(e) => {
                        field.onChange(e.target.value);
                        setVerificationCode(e.target.value);
                      }}
                    />
                  )}
                />
              </div>
              {getFormErrorMessage("verificationCode")}
            </div>

            <div className="p-field p-col-12 p-md-12 ">
              <label className="p-col-12 p-md-12" htmlFor="password">
                <i className="pi pi-key"></i> {t("password")}
              </label>
              <div className="p-inputgroup">
                <Controller
                  name="password"
                  control={control}
                  rules={{
                    required: "Password is required.", pattern: {
                      value: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/,
                      message: ""
                    }
                  }}
                  render={({ field, fieldState }) => (
                    <Password
                      className={'p-col-12  padding-rl-0 ' + classNames({ 'p-invalid': fieldState.invalid })}
                      feedback={false} type="password" onKeyUp={(e) => passwordKeyPressed(e)}
                      toggleMask
                      id={field.name}
                      {...field}
                      placeholder={t("password")}
                      onChange={(e) => {
                        field.onChange(e.target.value);
                        setPassword(e.target.value);
                      }}
                    />
                  )}
                />
              </div>
              {getFormErrorMessage("password")}
              <div className="p-col-12 p-md-12" style={{ padding: '5px 0px', display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
                <Tag style={{ margin: 5, fontSize: 11.5, borderRadius: '16px' }} value="Atleast 1 Lowercase required" icon={lowerCaseCheck} severity={lowerCaseColor}></Tag>
                <Tag style={{ margin: 5, fontSize: 11.5, borderRadius: '16px' }} value="Atleast 1 Uppercase required" icon={upperCaseCheck} severity={upperCaseColor}></Tag>
                <Tag style={{ margin: 5, fontSize: 11.5, borderRadius: '16px' }} value="Atleast 1 Number required" icon={minNumberCheck} severity={minNumberColor}></Tag>
                <Tag style={{ margin: 5, fontSize: 11.5, borderRadius: '16px' }} value="Atleast 1 Special Character required" icon={specialCharCheck} severity={specialCharColor}></Tag>
                <Tag style={{ margin: 5, fontSize: 11.5, borderRadius: '16px' }} value="Minimum of 8 Characters required" icon={lengthCheck} severity={lengthColor}></Tag>

              </div>
            </div>
            <div className="p-field p-col-12 p-md-12 ">
              <label className="p-col-12 p-md-12" htmlFor="rePassword">
                <i className="pi pi-key"></i>{t("rePassword")}
              </label>
              <div className="p-inputgroup">
                <Controller
                  name="rePassword"
                  control={control}
                  rules={{
                    required: 'Re Type Password is required.',
                    validate: (value) => {
                      // console.log(formState, value);
                      return control._formValues.password === value;
                    }
                  }}
                  render={({ field, fieldState }) => (
                    <Password feedback={false}
                      toggleMask
                      id={field.name}
                      {...field}
                      placeholder={t("rePassword")}
                      onChange={(e) => {
                        field.onChange(e.target.value);
                        setRePassword(e.target.value);
                      }}
                    />

                  )}
                />
              </div>
              {errors.rePassword && errors.rePassword.type === 'validate' && (showFormErrorMessage('Password confirmation does not match with new password')) || getFormErrorMessage('rpassword')}

            </div>

            <div className="p-field p-col-12 p-md-12" style={{ paddingTop: 20 }}>
              <Button type="submit" className="p-col-12" ><span style={{ textAlign: 'center', width: '100%' }} onClick={handleSubmit(saveNewPassword)}>Submit</span></Button>
            </div>
          </div>
        </div>

      </div>
    </div >
  );
};
export default ResetPassword;
